import React, { useState, useEffect } from 'react';

import { SelectableTable } from '../../../../common/table/SelectableTable';
import { SaveButton } from '../../../../common/button/save-button/SaveButton';

export const AvailableFormsSearch = ({ visit, forms, setVisit, visits, setVisits, closeModal, editMode }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [selectedForms, setSelectedForms] = useState([]);

  useEffect(() => {
    if (!forms || !visit) {
      setSearchResults([]);
      return;
    }

    const selectedRefs = editMode
      ? (visit.forms ?? []).map((f) => f.formExternalReference)
      : visit.formExternalReferences ?? [];

    const updated = forms.map((form) => ({
      ...form,
      selected: selectedRefs.includes(form.formExternalReference),
    }));

    setSearchResults(updated);

    setSelectedForms(updated);
  }, [forms, visit, editMode]);

  const handleSelectedFormsChange = (nextSelectedForms) => {
    setSelectedForms(nextSelectedForms);
  };

  const handleUpdateClick = () => {
    const selectedFormsFiltered = (selectedForms ?? []).filter((f) => f.selected);
    const selectedFormExternalReferences = selectedFormsFiltered.map((f) => f.formExternalReference);

    const newVisit = editMode
      ? {
          ...visit,
          forms: selectedFormsFiltered,
          formExternalReferences: selectedFormExternalReferences,
          noOfForms: selectedFormExternalReferences.length,
        }
      : {
          ...visit,
          formExternalReferences: selectedFormExternalReferences,
          noOfForms: selectedFormExternalReferences.length,
        };

    const index =
      visits.findIndex((v) => v.externalReference && v.externalReference === newVisit.externalReference) !== -1
        ? visits.findIndex((v) => v.externalReference === newVisit.externalReference)
        : visits.findIndex((v) => v.visitCode === newVisit.visitCode);

    if (index !== -1) {
      const updatedVisits = [...visits];
      updatedVisits[index] = newVisit;

      setVisit(newVisit);
      setVisits(updatedVisits);
    }

    closeModal();
  };

  return (
    <div className="problem-search-results-container">
      <div className="problem-search-results-table-container">
        {searchResults && (
          <SelectableTable
            tableData={searchResults}
            hiddenColumns={[
              'formExternalReference',
              'selected',
              'studyScheduleExternalReference',
              'scheduleSpecific',
              'studyScheduleName',
            ]}
            searchEnabled={true}
            filterEnabled={false}
            tableTitle={'Available Forms'}
            buttonDisabled={true}
            onSelectedFormsChange={handleSelectedFormsChange}
            selectedForms={selectedForms}
            maxRowCount={5}
          />
        )}
        <div className={'button-edit-container'}>
          <SaveButton color={'#deab26'} title={'Update'} onClick={handleUpdateClick} />
        </div>
      </div>
    </div>
  );
};
